<template>
  <section
    class="bg-white p-2 rounded-xl relative overflow-y-auto h-[calc(100vh-80px)] overflow-y-scroll"
  >
    <!-- Navbar Section -->
    <div class="border-b border-[#00000029] px-3 pb-1.5">
      <div class="icon-text">
        <h3
          class="fw-normal text-dark mb-0 ls-05"
          v-if="this.$route.query?.group && getSingleEntityGroupData?.name"
        >
          {{ getSingleEntityGroupData.name }}
        </h3>
        <span class="text-base text-gray-800" v-else>Form Templates</span>
      </div>
    </div>
    <div class="inner-navbar px-2.5">
      <div class="flex items-center w-full justify-end gap-2 py-2">
        <!-- Add to Company Profile Button -->
        <div v-if="selected_templates?.length && getActiveWorkspace?.plan_type !== 'INDIVIDUAL'">
          <button
            class="btn btn-outline-primary btn-sm me-3"
            type="button"
            @click="addToCompanyEntity"
          >
            <i class="fa fa-plus"></i>
            Add to company profile
          </button>
        </div>

        <!-- Search Input -->
        <div
          class="flex items-center justify-between gap-2 bg-white border border-gray-300 rounded-md text-xs"
        >
          <input
            type="text"
            class="px-2 py-1.5 outline-none min-h-[30px]"
            placeholder="Search"
            v-model="search_string"
            @input="searchString"
          />
          <img class="pr-1.5" src="../../assets/img/icons/new/search-icon.svg" alt="" />
        </div>

        <!-- Create Template Button -->
        <div v-if="checkPermissionByPermissionName('createFormTemplate')" class="">
          <button
            @click="scratchOrAi"
            style="background: var(--brand-500) !important"
            class="flex items-center justify-between gap-2 overflow-hidden border !rounded-md text-xs px-2 py-[5px] text-white"
          >
            <!-- <i class="fa fa-plus-circle"></i> -->
            <span>
              <img src="../../assets/img/icons/new/whiteplus-icon.svg" alt="" />
            </span>
            <span>
              {{ getIsMobile ? '' : 'Create Template' }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- Cards Section -->
    <div class="inner-navbar-content top">
      <div class="vue-data-table-default">
        <div class="template-cards pb-2">
          <div class="grid grid-cols-3 gap-3" style="width: 100% !important">
            <!-- Render placeholders if loading is true -->
            <template v-if="loading">
              <div v-for="index in 8" :key="index" class="col">
                <div class="card h-100 shadow-sm !bg-[#f6f6f6]">
                  <div class="card-header placeholder-glow !bg-[#f6f6f6]">
                    <span class="placeholder col-8"></span>
                  </div>
                  <div class="card-body !bg-[#ffffff]">
                    <p class="mb-2 placeholder-glow">
                      <span class="placeholder col-10"></span>
                    </p>
                    <p class="mb-2 placeholder-glow">
                      <span class="placeholder col-6"></span>
                    </p>
                    <p class="mb-0 placeholder-glow">
                      <span class="placeholder col-4"></span>
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <!-- Render actual data if loading is false -->
            <template v-else>
              <div v-for="template in data" :key="template._id" class="col">
                <div
                  class="h-[225px] border overflow-hidden border-[#00000008] !bg-[#f6f6f6] p-2 rounded-xl text-xs hover:scale-101 transition-all duration-200 ease-in-out"
                >
                  <div
                    class="flex justify-content-between align-items-center !bg-[#f6f6f6] !border-none"
                  >
                    <span class="text-truncate">{{ template.name }}</span>
                    <div class="dropdown">
                      <button
                        class="btn btn-link dropdown-toggle custom-dots text-decoration-none p-0"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      ></button>
                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <li>
                          <a class="dropdown-item" @click="onCustomTemplateView(template)">
                            <i class="fa fa-eye me-2"></i>
                            View
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" @click="onEdit(template)">
                            <i class="fa fa-edit me-2"></i>
                            Edit
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" @click="openDuplicateTemplateModal(template)">
                            <i class="fa fa-copy me-2"></i>
                            Duplicate
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" @click="onDelete(template)">
                            <i class="fa fa-trash me-2"></i>
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="px-3 py-2 h-[calc(100%-30px)] !bg-white rounded-[16px] flex flex-col justify-between"
                  >
                    <div class="w-full xl:max-w-md 2xl:max-w-full">
                      <p class="!mb-1 !text-[#828282]">Description</p>
                      <p class="!mb-1 line-clamp-3 !text-[#333333]">
                        <span>{{ template.description }}</span>
                      </p>
                    </div>
                    <!-- <div
                      class="line w-full !mb-1 height-[1px]"
                      style="
                        background-color: rgba(0, 0, 0, 0.12);
                        width: 100%;
                        height: 1px;
                      "
                    ></div> -->
                    <div class="flex pt-3 border-t border-[#0000001F] items-center justify-between">
                      <div class="flex items-center justify-between gap-2">
                        <div class="pb-3">
                          <img src="../../assets/img/icons/new/createdDate-icon.svg" />
                        </div>
                        <div>
                          <p class="mb-2 text-truncate !text-[#828282] !mb-1">Created At</p>
                          <p class="mb-2 text-truncate !text-[#333333]">
                            {{ template.created_at | globalDateTimeFormat }}
                          </p>
                        </div>
                      </div>
                      <div class="flex items-center justify-between gap-2">
                        <div class="pb-3">
                          <img src="../../assets/img/icons/new/lastmodified-icon.svg" />
                        </div>
                        <div>
                          <p class="mb-2 text-truncate !text-[#828282] !mb-1">Last Modified</p>
                          <p class="mb-2 text-truncate !text-[#333333]">
                            {{ template.updated_at | globalDateTimeFormat }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- Pagination -->
        <el-pagination
          class="py-2 absolute bottom-[-8px] bg-white"
          background
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[12, 24, 60, 120]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="loadDataPerPage"
          @current-change="loadData"
        ></el-pagination>
      </div>
    </div>
    <div class="main-container" v-if="showLandingPagePreview">
      <div class="header-top">
        <span>Preview Landing Page</span>
        <i class="fa fa-times close-icon" @click="showLandingPagePreview = false"></i>
      </div>
      <div class="!bg-black">
        <div v-loading="isLandingPageRegenate" :element-loading-text="loadingText">
          <NewPreviewTemplate
            :name="selectedCompanyTemplate.name"
            :fieldsData="preparedData"
          ></NewPreviewTemplate>
        </div>
      </div>

      <div class="dialog-footer-content">
        <div class="left-content">
          <div class="response-count">
            <el-tooltip content="Previous" placement="top">
              <i
                class="el-icon-arrow-left icon-button"
                @click="showPreviousResponse"
                :class="{ 'icon-disabled': currentResponseIndex <= 0 }"
              ></i>
            </el-tooltip>
            <span class="response-text">
              {{ currentResponseIndex + 1 }} / {{ responses.length }}
            </span>
            <el-tooltip content="Next" placement="top">
              <i
                class="el-icon-arrow-right icon-button"
                @click="showNextResponse"
                :class="{
                  'icon-disabled': currentResponseIndex === responses.length - 1,
                }"
                :style="{
                  cursor: currentResponseIndex === responses.length - 1 ? 'not-allowed' : 'pointer',
                }"
              ></i>
            </el-tooltip>
          </div>
          <div class="input-with-icon">
            <el-input
              v-model="landingPageRequestPrompt"
              type="textarea"
              autosize
              placeholder="Request for changes"
              class="input-field"
            ></el-input>
            <div class="icon-container">
              <el-tooltip
                v-if="!landingPageRequestPrompt"
                content="Please provide a prompt with at least 15 characters"
                placement="top"
              >
                <img
                  :src="iconSrcEnter"
                  class="suffix-icon"
                  alt="Enter Icon"
                  :style="{ cursor: 'not-allowed' }"
                  :class="'icon-disabled'"
                />
              </el-tooltip>
              <!-- Enabled state -->
              <img
                v-else
                :src="iconSrcEnter"
                class="suffix-icon"
                alt="Enter Icon"
                :style="{ cursor: 'pointer' }"
                @click="handleGenerateResponseForLandingPage(true)"
              />
            </div>
          </div>
          (or)
          <el-button
            class="regen-button"
            size="mini"
            @click="handleGenerateResponseForLandingPage()"
            :disabled="isLandingPageRegenate"
          >
            Regenerate
            <i class="el-icon-refresh"></i>
          </el-button>
        </div>
        <div class="right-content">
          <el-button
            type="primary"
            size="mini"
            class="continue-button"
            @click="openEditTemplateWithGeneratedResponse()"
            :disabled="isLandingPageRegenate || !preparedData.length"
          >
            Continue
          </el-button>
        </div>
      </div>
    </div>
    <!-- Duplicate Template Modal -->
    <dialog-component
      id="settingsDialog"
      v-loading.fullscreen.lock="duplicateLoading"
      :title="'Duplicate Template'"
      :visible="duplicateFromTemplateDialogVisible"
      :containerWidth="'23%'"
      @before-close="closeDialog"
      v-draggable
    >
      <div class="popUp-content">
        <label>Title :</label>
        <el-input
          type="text"
          @keyup.enter.native="handleEnterKey()"
          placeholder="Title"
          v-model="duplicateTemplateName"
        ></el-input>
      </div>
      <span slot="footer">
        <button
          class="!mr-1 !px-3 !py-1 !border !rounded-sm !border-black/10 hover:border hover:!border-brand-500 hover:text-brand-500"
          @click="closeDuplicateTemplateModal"
        >
          Cancel
        </button>
        <button
          class="!border !border-brand-500 !px-3 !py-1 !bg-brand-500 !text-white !rounded-sm"
          @click="duplicateTemplate()"
          :disabled="!duplicateTemplateName"
        >
          Confirm
        </button>
      </span>
    </dialog-component>

    <dialog-component
      id="settingsDialog"
      title="Create Template"
      :visible="dialogVisible"
      v-loading="createTemplateLoading"
      element-loading-text="Checking template Name"
      :containerMaxWidth="getIsMobile ? '80%' : '50%'"
      :containerMinHeight="getIsMobile ? '50%' : '50%'"
      @before-close="dialogVisible = false"
    >
      <div class="dialog-content">
        <el-row>
          <div class="flex flex-col items-center justify-center py-3 gap-3 text-start">
            <el-col>
              <div
                class="flex items-center justify-start gap-4 !border border-[#00000029] p-3 rounded-[6px] cursor-pointer transition delay-0 duration-300 ease-in-out hover:text- hover:-translate-y-0.3 hover:scale-101 !hover:border-4 hover:border-blue-300"
                @click="selectOption('template')"
                :style="{
                  borderColor: selectedOption === 'template' ? '#409eff' : '',
                }"
              >
                <div>
                  <img src="../../assets/img/icons/new/StartFromScratch-icon.svg" alt="" />
                </div>
                <div class="flex flex-col gap-2">
                  <div class="!text-gray-900">Start from scratch</div>
                  <div class="!text-xs">
                    Create a new form template by simply dragging and dropping from a list of
                    available fields.
                  </div>
                </div>
              </div>
            </el-col>
            <el-col>
              <div
                class="flex items-center justify-start gap-4 !border border-[#00000029] p-3 rounded-[6px] cursor-pointer transition delay-0 duration-300 ease-in-out hover:text- hover:-translate-y-0.3 hover:scale-101 !hover:border-4 hover:border-blue-300"
                @click="selectOption('ai')"
                :style="{
                  borderColor: selectedOption === 'ai' ? '#409eff' : '',
                }"
              >
                <div>
                  <img src="../../assets/img/icons/new/CreateWithAI-icon.svg" alt="" />
                </div>
                <div class="flex flex-col gap-2">
                  <div class="!text-gray-900">Create with AI</div>
                  <div class="!text-xs">
                    Provide some details, and AI will create a complete form template for you.
                  </div>
                </div>
              </div>
            </el-col>
            <el-col>
              <div
                class="flex items-center justify-start gap-4 !border border-[#00000029] p-3 rounded-[6px] cursor-pointer transition delay-0 duration-300 ease-in-out hover:text- hover:-translate-y-0.3 hover:scale-101 !hover:border-4 hover:border-blue-300"
                @click="selectOption('landingPage')"
                :style="{
                  borderColor: selectedOption === 'landingPage' ? '#409eff' : '',
                }"
              >
                <div>
                  <img src="../../assets/img/icons/new/LandingPage-icon.svg" alt="" />
                </div>
                <div class="flex flex-col gap-2">
                  <div class="text-gray-900">Landing Page</div>
                  <div class="text-xs">
                    Quickly set up a landing page with pre-built templates and customization
                    options.
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
      <div>
        <div v-if="form_field" class="mt-1">
          <el-form>
            <el-form-item label="Form Template Name">
              <span class="text-danger">*</span>
              <el-input
                type="text"
                placeholder="Enter the form template name"
                v-model="formTemplateName"
                @keydown.enter.native.prevent="handleEnter"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="landingPageNameInput" class="mt-1">
          <el-form>
            <el-form-item label="Enter Landing Page Name">
              <span class="text-danger">*</span>
              <el-input
                type="text"
                placeholder="Enter Landing Page Name"
                v-model="formTemplateName"
                @keydown.enter.native.prevent="handleEnter"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
        <el-button
          v-if="selectedOption === 'ai' || selectedOption === 'landingPage'"
          type="primary"
          @click="createTemplate(selectedOption)"
          size="small"
          :disabled="!formTemplateName"
        >
          Create
        </el-button>
      </span>
    </dialog-component>
    <div class="modal-overlay" v-if="landingPageDialog">
      <div class="modal-container">
        <div class="modal-header">
          <div class="modal-title">Create with AI</div>
          <div class="modal-close">
            <i class="fa fa-times" @click="closeLandingPageDialog"></i>
          </div>
        </div>
        <div v-if="!isLandingPageGenerating">
          <div class="content-wrapper">
            <div class="image-box">
              <img src="@/assets/img/Describe.svg" />
            </div>
            <div class="text-box">
              <div class="text-title">Describe your page</div>
            </div>
            <div class="input-box">
              <label for="pageDescription">Describe your page in a few words or sentences</label>
              <el-input
                type="textarea"
                rows="4"
                placeholder="Create a landing page for"
                v-model="landingPage_prompt"
              ></el-input>
            </div>
            <el-button
              type="primary"
              :disabled="landingPage_prompt.length < 15"
              size="mini"
              class="generate-button"
              @click="handleGenerateResponseForLandingPage()"
            >
              {{ getIsMobile ? 'Generate' : 'Generate Landing Page' }}
            </el-button>
          </div>
          <div class="example-text">
            (Ex: Create a landing page featuring a captivating hero section, testimonials, pricing
            options. Ensure a clear call-to-action and include links to social media for
            engagement.)
          </div>
        </div>

        <div class="loading-wrapper" v-else>
          <div class="loading-box">
            <img height="100px" width="100px" :src="iconSrc" alt="Loading..." />
            <p>Creating the magic of AI – please wait while we generate...</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { TimelineLite, Bounce, Elastic } from 'gsap/dist/gsap';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper';
  import {
    getAllCompanyTemplatesByPagination,
    deleteTemplate,
    addSingleTemplateToLocal,
  } from '../../repo/templatesRepo';
  import { postAPICall } from '@/helpers/httpHelper';
  import authHelper from '@/mixins/authHelper';
  export default {
    name: 'templates-Templates-List',
    computed: {
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('companyTemplates', [
        'getAllCompanyTemplatesData',
        'getTemplateDeleteStatus',
        'getTemplateDeleteError',
        'getDuplicateFormTemplateError',
        'getDuplicateFormTemplateStatus',
      ]),
      ...mapGetters('entities', ['getAddEntityToCompanyStatus', 'getCompanyEntity']),
      ...mapGetters('auth', ['getActiveWorkspace']),

      ...mapGetters('entityGroups', ['getSingleEntityGroupData']),
      ...mapGetters('roles', ['getRoleById', 'getSuccess', 'getRoleErrors']),

      ...mapGetters('auth', ['getAuthenticatedUser']),
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [12, 24, 60],
        };
      },
    },

    components: { NewPreviewTemplate: () => import('./NewPreviewTemplate.vue') },
    mixins: [PermissionsHelper, NavigationHelper, authHelper, TemplateBuilderHelper],
    async mounted() {
      this.timeline = new TimelineLite({
        // onComplete: () => this.timeline.restart()
      });
      await this.fetchGroupDetails();
      this.fetchAllCompanyTemplates();
      // this.animateStatSections();
    },
    data() {
      return {
        showLandingPagePreview: false,
        iconSrc: require('@/assets/Animation.gif'),
        iconSrcEnter: require('@/assets/Enter-Active.svg'),
        generageFlag: false,
        isLandingPageGenerating: false,
        isLandingPageRegenate: false,
        loadingText: '',
        landingPageDialog: false,
        landingPageNameValidation: false,
        landingPage_prompt: '',
        landingPageRequestPrompt: '',
        preparedData: [],
        responses: [],
        currentResponseIndex: -1,
        landingPageNameInput: false,
        formTemplateId: null,
        pageSizes: [12, 24, 60],
        duplicateTemplateName: '',
        duplicateLoading: false,
        duplicateFromTemplateDialogVisible: false,
        loading: false,
        selectedOption: null,
        selectedCompanyTemplate: {},
        total: 0,
        currentPage: 1,
        pageSize: 0,
        order_type: null,
        order_by: null,
        data: [],
        previewDialogVisible: false,
        timeline: null,
        search_string: '',
        temp_total: 0,
        selected_templates: [],
        dialogVisible: false,
        AddDialogVisible: false,
        form_field: false,
        formTemplateName: '',
        createTemplateLoading: false,
      };
    },
    beforeDestroy() {
      this.$store.commit(
        'navigationOpen/setCurrentMenu',
        {},
        {
          root: true,
        }
      );

      this.$store.commit(
        'companyTemplates/setAllCompanyTemplatesData',
        {
          data: [],
        },
        {
          root: true,
        }
      );
    },
    methods: {
      async handleGenerateResponseForLandingPage(isLandingPageChanges = false) {
        this.loadingText = isLandingPageChanges
          ? 'We are preparing your changes...'
          : 'We are regenerating your landing page...';

        this.isLandingPageRegenate = true;
        try {
          await this.generateResponseForLandingPage(isLandingPageChanges);
        } finally {
          this.isLandingPageRegenate = false;
        }
      },
      async openEditTemplateWithGeneratedResponse() {
        try {
          if (!this.preparedData || !this.preparedData.length) {
            this.$message.error(
              'No landing page data found. Please generate the landing page first.'
            );
            return;
          }
          const templateParams = {
            fields: this.preparedData,
            template_name: this.selectedCompanyTemplate.name,
            template_id: `newTemplate#${this.selectedCompanyTemplate.name}#${this.selectedCompanyTemplate.name}`,
            noTemplateCreate: true,
          };

          const templateResponse = await postAPICall(
            'POST',
            '/template/createTemplateFromJson',
            templateParams
          );
          if (templateResponse?.data?._id) {
            this.generatedTemplateId = templateResponse.data._id;
          }

          this.$router.push({
            name: 'Edit Templates',
            params: { template_id: this.generatedTemplateId },
            query: {
              key: Math.floor(Math.random() * 100000),
            },
          });
        } catch (err) {
          console.error('Error navigating to edit template:', err);
          this.$message.error(
            'Failed to create the template or navigate to the edit template page.'
          );
        }
      },
      closeLandingPageDialog() {
        this.landingPageDialog = false;
        let query = { ...this.$route.query };
        delete query.template_name;
        this.$router.push({ query });
        this.dialogVisible = false;
      },
      showPreviousResponse() {
        if (this.currentResponseIndex > 0) {
          this.currentResponseIndex--;
          const response = this.responses[this.currentResponseIndex];
          this.landingPageRequestPrompt = response.prompt;
          this.preparedData = response.data;
        }
      },
      showNextResponse() {
        if (this.currentResponseIndex < this.responses.length - 1) {
          this.currentResponseIndex++;
          const response = this.responses[this.currentResponseIndex];
          this.landingPageRequestPrompt = response.prompt;
          this.preparedData = response.data;
        }
      },
      async fetchGroupDetails() {
        if (this.$route.query.group && this.$route.query.group.length) {
          await this.$store.dispatch(
            'entityGroups/fetEntityGroupDataById',
            this.$route.query.group
          );
        }
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
          await this.$store.dispatch(
            'roles/fetchRoleById',
            this.getAuthenticatedUser.activeRole.role_id
          );
        }
      },
      closeDialog() {
        this.duplicateFromTemplateDialogVisible = false;
      },
      scratchOrAi() {
        this.dialogVisible = true;
      },

      formOpen() {
        this.form_field = true;
      },
      landingPageValidation() {
        this.landingPageNameInput = true;
      },
      handleEnter() {
        let type = this.landingPageNameInput ? 'landingPage' : 'ai';
        this.createTemplate(type);
      },
      selectOption(option) {
        this.selectedOption = option;
        this.form_field = false;
        this.landingPageNameInput = false;
        if (option === 'template') {
          this.createTemplate('template');
        } else if (option === 'ai') {
          this.formOpen();
        } else if (option === 'landingPage') {
          this.landingPageValidation();
        }
      },

      openDuplicateTemplateModal(template) {
        this.duplicateTemplateName = template.name + '-Dup';
        this.formTemplateId = template._id;
        this.duplicateFromTemplateDialogVisible = true;
      },
      closeDuplicateTemplateModal() {
        this.duplicateFromTemplateDialogVisible = false;
      },
      getTemplateSlug() {
        return this.duplicateTemplateName.trim().toLowerCase().split(' ').join('-');
      },
      checkPermissions() {
        if (!this.checkPermissionByPermissionName('createFormTemplate')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for create template. Please contact owner.!',
          });
        }
      },
      async addToCompanyEntity() {
        try {
          this.loading = true;
          let params = {
            templates: this.selected_templates.flatMap((e) => e._id),
          };
          await this.$store.dispatch('entities/addCompanyEntity', params);
          if (this.getAddEntityToCompanyStatus) {
            let alreadyAdded = this.selected_templates
              .filter((tmp) =>
                this.getCompanyEntity.templates.map((t) => t.template_id).includes(tmp._id)
              )
              .map((tmp) => tmp.name);
            let message =
              `${params.templates.length - alreadyAdded.length}` +
              ' templates added to company profile successfully. ';
            message += alreadyAdded.length
              ? alreadyAdded.join(', ') +
                (alreadyAdded.length > 1 ? ' were' : ' was') +
                ' already in the company profile.'
              : '';
            this.loading = false;
            this.$notify.success({
              title: 'Success',
              message: message,
            });
            this.fetchAllCompanyTemplates();
          } else {
            this.loading = false;
            this.$notify.error({
              title: 'Error',
              message: 'Error on adding templates',
            });
          }
        } catch (er) {
          console.log('addToCompanyEntity', er);
        }
      },
      async sortChange(a) {
        this.order_by = a.prop;
        this.order_type = a.order == 'ascending' ? 'asc' : 'desc';
        this.fetchAllCompanyTemplates();
        if (a.order == null) {
          this.order_by = null;
          this.order_type = null;
          this.fetchAllCompanyTemplates();
        }
      },
      handleSelectionChange(val) {
        this.selected_templates = [];
        this.selected_templates = val;
      },
      async fetchAllCompanyTemplates() {
        this.loading = true;
        if (this.pageSize == 0) {
          this.pageSize = 12;
        }
        let params = {
          page: this.currentPage,
          limit: this.pageSize,
        };
        if (this.order_by) {
          params.order_by = this.order_by;
        }
        if (this.order_type) {
          params.order_type = this.order_type;
        }
        if (this.$route.query.group && this.$route.query.group.length) {
          params.group = this.$route.query.group;
        }
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
          if (this.getRoleById && this.getRoleById) {
            params.groups = this.getRoleById.allowed_groups;
          }
        }

        if (this.search_string) {
          params.search_string = this.search_string;
        }
        // await this.$store.dispatch(
        //   "companyTemplates/getAllCompanyTemplates",
        //   params
        // );
        const getAllCompanyTemplatesData = await getAllCompanyTemplatesByPagination(params);

        // this.currentPage = this.getAllCompanyTemplatesData.page
        //   ? parseInt(this.getAllCompanyTemplatesData.page)
        //   : 1;
        this.total = getAllCompanyTemplatesData.total
          ? parseInt(getAllCompanyTemplatesData.total)
          : 0;
        this.data = getAllCompanyTemplatesData.data || [];
        this.loading = false;
      },
      async refreshTemplates() {
        this.currentPage = 1;
        this.pageSize = 12;
        this.fetchAllCompanyTemplates();
      },
      searchString() {
        this.pageSize = 12;
        this.page = 1;
        this.fetchAllCompanyTemplates();
      },
      async loadData(val) {
        this.currentPage = val;
        await this.fetchAllCompanyTemplates();
      },
      async loadDataPerPage(val) {
        this.pageSize = val;
        await this.fetchAllCompanyTemplates();
      },
      async goToEditTemplate(templateId) {
        if (!this.checkPermissionByPermissionName('editFormTemplate')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for edit template. Please contact owner! ',
          });
        } else {
          let query = this.getNavigationQuery(this.$route.query);
          this.$router.push({
            name: 'Edit Templates',
            params: { template_id: templateId },
            query,
          });
        }
      },

      async createTemplate(type) {
        try {
          let query = this.getNavigationQuery(this.$route.query);
          if (type === 'landingPage') {
            if (!this.formTemplateName.trim()) {
              return this.$message.warning('Please enter a valid Landing Page Name.');
            }
            this.createTemplateLoading = true;
            let resp = await postAPICall('POST', `/template/checkTemplateExists`, {
              template_name: this.formTemplateName,
            });
            this.createTemplateLoading = false;
            if (!resp?.success) {
              return this.$message.error('Landing Page Already Exists with the same name.');
            }
            this.$router.push({
              query: {
                template_name: this.formTemplateName,
              },
            });
            this.landingPage_prompt = `Create Landing page for ${this.formTemplateName}`;
            this.landingPageDialog = true;
            return;
          }
          if (type != 'template') {
            this.createTemplateLoading = true;
            let resp = await postAPICall('POST', `/template/checkTemplateExists`, {
              template_name: this.formTemplateName,
            });
            this.createTemplateLoading = false;
            if (!resp?.success) {
              return this.$message.error('Template Already Exists with same name');
            }
          }
          let path =
            type == 'template'
              ? '/template/create'
              : `/template/create-with-ai?template_name=${this.formTemplateName}`;
          this.$router.push({
            path: path,
            query,
          });
        } catch (err) {
          this.createTemplateLoading = false;
          return this.$message.error('Template Already Exists with same name');
        }
      },

      async goToViewTemplate(templateId) {
        let query = this.getNavigationQuery(this.$route.query);
        this.$router.push({
          name: 'ViewTemplate',
          params: { template_id: templateId },
          query,
        });
      },

      onEdit(template) {
        if (!this.checkPermissionByPermissionNameFormTemplates(template, 'editFormTemplate')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for edit template. Please contact owner! ',
          });
        } else {
          this.goToEditTemplate(template._id);
        }
      },
      onView(template) {
        let templateCopy = JSON.parse(JSON.stringify(template));
        this.selectedCompanyTemplate.name = '';
        this.selectedCompanyTemplate.fieldsData = [];
        this.selectedCompanyTemplate.name = templateCopy.name;

        if (templateCopy.type == 'CONFIGURABLE') {
          let defaultSection = templateCopy.sections.find(
            (x) => x && x.type && x.type == 'DEFAULT'
          );
          this.selectedCompanyTemplate.fieldsData = defaultSection.fields.map((x) => {
            if (x.options && x.options.length) {
              x.options = x.options.join(',');
            }
            return x;
          });
          this.previewDialogVisible = true;
        }
      },
      async duplicateTemplate() {
        this.duplicateLoading = true;
        let params = {
          name: this.duplicateTemplateName,
          templateId: this.formTemplateId,
          slug: this.duplicateTemplateName.trim().toLowerCase().split(' ').join('-'),
        };
        try {
          const response = await postAPICall('POST', '/template/duplicateFormTemplate', params);
          if (response?.data) {
            addSingleTemplateToLocal(response.data);
          }
          this.duplicateLoading = false;
          this.duplicateFromTemplateDialogVisible = false;
          await this.fetchAllCompanyTemplates();
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: e?.response?.data?.message || 'Error in duplicating form template',
          });
          this.duplicateLoading = false;
        }
        // await this.$store.dispatch(
        //   "companyTemplates/duplicateFormTemplate",
        //   params
        // );
        // this.duplicateLoading = false;
        // if (this.getDuplicateFormTemplateStatus) {
        //   this.$notify.success({
        //     title: "Success",
        //     message: "Template Duplicated Successfully.",
        //   });
        //   this.duplicateFromTemplateDialogVisible = false;
        //   this.duplicateLoading = false;
        //   await this.fetchAllCompanyTemplates();
        // } else {
        //   this.$notify.error({
        //     title: "Error",
        //     message: this.getDuplicateFormTemplateError
        //       ? this.getDuplicateFormTemplateError
        //       : "Error in duplicating form template",
        //   });
        // }
      },
      onCustomTemplateView(template) {
        if (!this.checkPermissionByPermissionNameFormTemplates(template, 'viewUserFormTemplate')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for view template. Please contact owner! ',
          });
        } else {
          this.goToViewTemplate(template._id);
        }
      },
      async onDelete(row) {
        if (!this.checkPermissionByPermissionNameFormTemplates(row, 'deleteFormTemplate')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for delete templates. Please contact owner.!',
          });
        } else {
          this.$confirm('Are you sure to delete the Template?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.deleteTemplate(row);
          });
        }
      },
      async deleteTemplate(template) {
        let params = {
          id: template._id,
        };
        await this.$store.dispatch('companyTemplates/deleteCompanyTemplate', params);
        if (this.getTemplateDeleteStatus) {
          this.$notify.success({
            title: 'Success',
            message: 'Template deleted successfully',
          });
          await deleteTemplate(template._id);
          this.refreshTemplates();
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getTemplateDeleteError || 'Error on deleting template',
          });
        }
      },

      animateStatSections() {
        const {
          statOne,
          statOneIcon,
          statOneContent,
          statTwo,
          statTwoIcon,
          statTwoContent,
          statThree,
          statThreeIcon,
          statThreeContent,
        } = this.$refs;

        // this.timeline.to([statOne, statTwo, statThree], 0, {
        //   autoAlpha:0
        // })

        this.timeline
          .from(statOne, 1.5, {
            autoAlpha: 0,
            scale: 1.25,
            ease: Bounce.easeOut,
          })
          .from(
            statOneContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statOneIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );

        this.timeline
          .from(
            statTwo,
            1.5,
            {
              autoAlpha: 0,
              scale: 1.25,
              ease: Bounce.easeOut,
            },
            '-=1'
          )
          .from(
            statTwoContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statTwoIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );

        this.timeline
          .from(
            statThree,
            1.5,
            {
              autoAlpha: 0,
              scale: 1.25,
              ease: Bounce.easeOut,
            },
            '-=1'
          )
          .from(
            statThreeContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statThreeIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );
      },
      handleEnterKey() {
        this.duplicateTemplate();
      },
    },

    watch: {
      '$route.query.group'() {
        this.fetchAllCompanyTemplates();
        this.animateStatSections();
      },
      '$route.query.key'() {
        this.fetchAllCompanyTemplates();
        this.animateStatSections();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .main-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    font-size: 18px;
    color: white;
    font-weight: bold;
    background: var(--primary-color-brand);
  }

  .close-icon {
    font-size: 20px;
    cursor: pointer;
    color: white;
    transition: color 0.3s ease;
  }

  .close-icon:hover {
    color: #ccc;
  }

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: white;
    overflow-y: auto;
    scrollbar-width: thin;
    position: relative;
  }

  .content > * {
    flex-grow: 1;
  }

  .dialog-footer-content {
    display: flex;
    height: 80px;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: rgba(240, 240, 240, 1);
  }

  .left-content {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .response-count {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .response-text {
    font-size: 14px;
    color: #333;
  }

  .input-with-icon {
    position: relative;
  }

  .input-field {
    width: 300px;
    margin-left: 10px;
  }

  .input-with-icon .suffix-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transition: opacity 0.3s ease;
  }

  .suffix-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
  }

  .regen-button {
    margin-left: 10px;
  }

  .right-content {
    display: flex;
    align-items: center;
  }

  .continue-button {
    font-weight: bold;
    color: #fff;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .modal-container {
    height: 600px;
    width: 800px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    width: 100%;
    background: var(--primary-color-brand);
    color: white;
    font-size: 18px;
  }

  .modal-title {
    font-weight: bold;
    margin-left: 18px;
  }

  .modal-close {
    cursor: pointer;
    font-size: 18px;
    margin-right: 10px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 20px;
    border: 1px dashed black;
    margin: 50px 80px 20px 80px;
  }

  .text-box {
    text-align: center;
  }

  .text-title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 5px;
  }

  .input-box {
    width: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .generate-button {
    align-self: center;
    background-color: var(--brand-500);
    color: white !important;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
  }

  .example-text {
    font-size: 14px;
    color: #777;
    text-align: center;
    margin: 0px 70px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }

  .loading-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .loading-box img {
    margin-bottom: 10px;
  }

  .inner-navbar-content.top {
    margin-top: 0px !important;
  }

  .template-dashboard-view {
    // width: 90%;
    // display: table;
    margin: 0 auto;

    .search_input {
      // height: 29px !important;
    }

    .add-button {
      height: 32px;
      border: 1.5px solid #285ed3;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 0em 0.65em;
      color: #285ed3;
      background: #ecf5ff;
      border-color: #b3d8ff;

      &:hover {
        background: #409eff;
        border-color: #409eff;
        color: #ffffff;
      }
    }

    .inner-navbar-content {
      margin-top: 20px;
    }

    .guide-stats-block {
      padding: 1em 0 2em;

      .each-stat {
        position: relative;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 1em 1em 0.75em;
        color: #ffffff;
        overflow: hidden;
        min-height: 105px;

        &.stat-card-one {
          background-color: #ff83a1;
        }

        &.stat-card-two {
          background-color: #5673dc;
        }

        &.stat-card-three {
          background-color: #ffbd12;
        }

        .icon {
          position: relative;
          z-index: 3;

          img {
            max-height: 50px;
          }
        }

        .cover {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -10px;
          z-index: 1;

          img {
            width: 100%;
          }
        }

        .stat-content {
          position: relative;
          z-index: 2;
        }

        h3 {
          font-size: 3em;
          font-weight: 300;
          line-height: 1;
          text-align: center;
        }

        p {
          position: absolute;
          text-align: right;
          bottom: 0;
          right: 0;
        }
      }

      .usage-guide {
        position: relative;
        min-height: 105px;
        display: flex;
        background-color: #ebf0f3;
        border-radius: 8px;
        padding: 1em 1em 0.75em;
        overflow: hidden;

        .content {
          position: relative;
          z-index: 2;
        }

        .icon-right {
          width: 200px;
          position: relative;
          z-index: 3;
        }

        h4 {
          font-size: 1em;
          margin: 0;
          font-weight: 400;
        }

        p {
          font-size: 0.75em;
          line-height: 1.3;
          margin: 0.25em 0 0.75em;
        }

        .el-button {
          font-size: 0.85em;
          padding: 0.35em 0.75em;
          background-color: #6979f8;

          &:hover {
            background-color: #4558e9;
          }
        }

        .cover {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -10px;
          z-index: 1;

          img {
            width: 100%;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .templates-list-view {
    .el-table {
      td:first-child {
        .cell {
          text-overflow: unset !important;
        }
      }
    }

    .el-table__cell {
      padding: 5px 5px !important;
      font-size: 14px;
    }
  }
</style>
<style lang="scss" scoped>
  @media (min-width: 768px) {
    .left-title {
      margin-top: 10px;
    }

    .right-search-input {
      margin-top: 20px;
    }

    .right-create-button {
      margin-top: 20px;
    }
  }

  @media (max-width: 426px) {
    .right-search-input {
      margin-bottom: 30px !important;
      margin-left: 50px !important;
      margin-top: -30px;
      float: right !important;
    }

    .right-create-button {
      margin-bottom: 20px !important;
      float: right !important;
      margin-top: -30px;
    }
  }

  .inner-navbar {
    display: flex;
    justify-content: space-between;

    @media (max-width: 650px) {
      flex-direction: column;

      .left-title {
        margin-bottom: 10px;
      }
    }

    .left-title {
      .icon-block {
        display: flex;
        margin-top: 10px;

        .icon {
          width: 30px;
          margin-right: 10px;
        }

        .icon-text {
        }
      }
    }

    .right-block {
      display: flex;

      .right-search-input {
        margin-right: 10px;

        // height: 50px;
        @media (max-width: 650px) {
          margin-right: 0px;
          margin-bottom: 10px;
        }
      }

      .right-create-button {
      }

      @media (max-width: 650px) {
        align-items: end;
      }
    }
  }
</style>
<style lang="scss">
  .form-template-list-mobile {
    .el-table__body {
      .el-table__row {
        & > td {
          &:first-child {
            padding: 0px;
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .bt .btn-outline-primary {
    @media (max-width: 767px) {
      position: relative;
      bottom: 10px;
    }
  }

  .bt .btn-outline-primary {
    color: white !important;
    background: var(--brand-500) !important;

    // border-color: var(--brand-500);
    // &:hover {
    //   color: var(--primary-contrast-color);
    //   background: var(--primary-color-brand);
    //   border-color: var(--brand-500);
    // }
    &:active:focus {
      color: white !important;
      background: var(--brand-500) !important;
      // border-color: var(--brand-500) !important;
      box-shadow: 0 0 0 0.2rem var(--primary-color-brand) !important;
    }
  }
</style>
<style scoped>
  .dialog-content {
    text-align: center;
    margin: 10px 20px 20px 20px;
  }

  .option {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s;
    width: 206px;
    height: 242px;
    margin-top: 10px;
  }

  .option-card:hover {
    transform: translateY(-5px);
    border-color: #409eff;
  }

  .icons {
    font-size: 36px;
    color: #409eff;
  }

  .el-icon-plus {
    margin-top: 40px;
  }

  .plus-symbol {
    background: #f5f9ff;
    width: 100%;
    height: 50%;
    border-radius: 4px;
  }

  .star-symbol {
    background: #f5f9ff;
    z-index: 1;
    width: 100%;
    height: 50%;
    border-radius: 4px;
  }

  .star-symbol img {
    margin-top: 36px;
  }

  .Title {
    font-size: 20px;
    margin-top: 10px;
    font-weight: bold;
    color: #303133;
    text-align: left;
  }

  .description {
    font-size: 12px;
    color: #303133;
    margin-top: 10px;
    text-align: left;
    line-break: normal;
    white-space: pre-line;
  }

  .each-card {
    padding: 1rem;
    height: 30vh;
    min-width: 20vw;
  }

  @media (max-width: 768px) {
    .each-card {
      padding: 1rem;
      margin-bottom: 20px;
    }

    .option {
      height: 40%;
      width: 65%;
      margin-left: 1px;
    }

    .el-icon-plus {
      position: relative;
      bottom: 10px;
    }

    ::v-deep .star-symbol {
      height: 60%;
    }

    .option-card img {
      margin-top: 33px;
    }

    .option-card .Title {
      margin-top: 20px;
    }

    .option-card .description {
      margin-top: 47px;
    }

    .option-card {
      margin-top: 10px;
    }
  }
</style>

<style scoped>
  .template-cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .columns-wrapper {
    max-height: 78vh;
    height: 78vh;
    overflow: auto;
    scrollbar-width: thin;
  }

  .each-card {
    transition: transform 0.3s ease-in-out;
  }

  .hover-scale:hover {
    /* transform: scale(1.02); */
    /* border-color: slategray; */
    border-radius: 20px;
    box-shadow: 0px 5px 10px 0px #c0c4cc;
  }

  @media (max-width: 768px) {
    .template-cards {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
  }

  .el-dropdown {
    display: inline-block;
    position: relative;
    color: white;
    font-size: 14px;
    background-color: slategrey;
    border-radius: 10px;
    padding: 2px 5px;
  }

  .el-pagination {
    display: flex;
    justify-content: center;
    position: sticky;
  }
</style>

<style scoped>
  .template-dashboard-view {
    padding: 0px 20px;
  }

  .template-cards .card {
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease;
    height: 11rem !important;
    /* Ensure consistent card height */
  }

  .template-cards .card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    z-index: 1 !important;
  }

  .template-cards .card-header {
    background-color: #f8f9fa;
    font-weight: 600;
    min-height: 60px;
    /* Ensure consistent header height */
  }

  .card-body {
    min-height: 200px;
    /* Ensure consistent body height */
  }

  .card-body p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .placeholder-glow .placeholder {
    display: inline-block;
    height: 1rem;
    background: linear-gradient(90deg, #e9ecef 25%, #f8f9fa 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: placeholder-glow 1.2s ease infinite;
    border-radius: 4px;
  }

  .placeholder-glow .placeholder.col-8 {
    width: 75%;
  }

  .placeholder-glow .placeholder.col-10 {
    width: 90%;
  }

  .placeholder-glow .placeholder.col-6 {
    width: 60%;
  }

  .placeholder-glow .placeholder.col-4 {
    width: 40%;
  }

  @keyframes placeholder-glow {
    from {
      background-position: 200% 0;
    }

    to {
      background-position: -200% 0;
    }
  }
</style>
/* pagination styles */
<style>
  /* Pagination container */
  .el-pagination[background] {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    background: black !important;
    /* Light gray background */
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin: 16px 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  /* Pagination buttons (prev, next, pager) */
  .el-pagination[background] .btn-prev,
  .el-pagination[background] .btn-next,
  .el-pagination[background] .el-pager li {
    background-color: #ffffff;
    /* White background for buttons */
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin: 0 4px;
    padding: 8px 12px;
    font-size: 14px;
    color: #606266;
    transition: all 0.3s ease;
    min-width: 32px;
    text-align: center;
  }

  /* Hover effect */
  .el-pagination[background] .btn-prev:hover:not(:disabled),
  .el-pagination[background] .btn-next:hover:not(:disabled),
  .el-pagination[background] .el-pager li:hover:not(.active) {
    background-color: #409eff;
    color: #ffffff;
    border-color: #409eff;
  }

  /* Active page */
  .el-pagination[background] .el-pager li.active {
    background-color: #409eff;
    color: #ffffff;
    border-color: #409eff;
    font-weight: 600;
    cursor: default;
  }

  /* Disabled buttons */
  .el-pagination[background] .btn-prev:disabled,
  .el-pagination[background] .btn-next:disabled {
    background-color: #f4f4f5;
    color: #c0c4cc;
    border-color: #e4e7ed;
    cursor: not-allowed;
  }

  /* Page size selector */
  .el-pagination[background] .el-select .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding: 0 24px 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #606266;
    background-color: #ffffff;
  }

  /* Total and jumper text */
  .el-pagination[background] .el-pagination__total,
  .el-pagination[background] .el-pagination__jump {
    font-size: 14px;
    color: #606266;
    margin: 0 8px;
  }

  /* Jumper input */
  .el-pagination[background] .el-pagination__jump .el-input__inner {
    width: 60px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    text-align: center;
    font-size: 14px;
    background-color: #ffffff;
  }

  /* Responsive design */
  @media (max-width: 600px) {
    .el-pagination[background] {
      flex-wrap: wrap;
      gap: 8px;
      padding: 12px;
    }

    .el-pagination[background] .btn-prev,
    .el-pagination[background] .btn-next,
    .el-pagination[background] .el-pager li {
      padding: 6px 8px;
      font-size: 12px;
      min-width: 28px;
    }

    .el-pagination[background] .el-pagination__total,
    .el-pagination[background] .el-pagination__jump {
      font-size: 12px;
    }

    .el-pagination[background] .el-select .el-input__inner {
      height: 28px;
      font-size: 12px;
    }

    .el-pagination[background] .el-pagination__jump .el-input__inner {
      width: 50px;
      height: 28px;
    }
  }
</style>
